import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { AgGridReact } from "ag-grid-react"; // AG Grid Component
import { BanksAPI, ECartItemsAPI, SellersAPI, StoresAPI } from "api";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";
import TableHeaderDropdown from "components/common/TableHeaderDropdown";
import { settings } from "config";
import { useCallback, useRef, useState } from "react";
import { Card, Dropdown, Form } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { CONSTANT_ROUTES } from "routes";
import PageTitle from "utils/PageTitle";
import {
  resetColumnState,
  restoreColumnState,
  saveColumnState,
} from "utils/tablesUtils";
import "../styles.css";
import AddBank from "../views/bank-account-view/add-bank/AddBank";

export default function BanksTable() {
  let isDarkBool = localStorage.getItem("isDark") === true;
  let isDarkTheme = localStorage.getItem("theme") === "dark";
  let auto = localStorage.getItem("theme") === "auto";
  const navigate = useNavigate();
  const location = useLocation();
  const columnApiRef = useRef();
  const gridRef = useRef();
  const [storeInformationData, setStoreInformationData] = useState(null);

  const [colDefs] = useState([
    // { field: "", filter: false, headerName: "Select" },

    {
      field: "title",
      headerName: "Title",
      hide: false,
      flex: 2,
    },
    {
      field: "name",
      headerName: "Name",
      hide: false,
      flex: 2,
    },
    {
      field: "ntn",
      headerName: "NTN",
      hide: false,
      flex: 2,
    },
    {
      field: "iban",
      headerName: "IBAN",
      hide: false,
      flex: 2,
    },
    {
      field: "status",
      headerName: "Active",
      hide: false,
      flex: 1.5,
      filter: false,
      cellStyle: {
        display: "flex",
        // paddingRight: "30px",
        justifyContent: "center",
      },
      headerClass: "center-header",
      cellRenderer: (p) => (
        <Form.Check
          type="checkbox"
          id="statusSwitch"
          style={{ padding: "10px 0px" }}
          checked={p?.data.status}
        />
      ),
    },
    // {
    //   field: "status",
    //   headerName: "Active",
    //   hide: false,
    //   flex: 1.5,
    //   filter: false,
    //   cellStyle: {
    //     display: "flex",
    //     // paddingRight: "30px",
    //     justifyContent: "center",
    //   },
    //   headerClass: "center-header",
    //   cellRenderer: (p) => (
    //     <Form.Check
    //       type="checkbox"
    //       id="statusSwitch"
    //       style={{ padding: "10px 0px" }}
    //       checked={p?.data.status}
    //     />
    //   ),
    // },
    // {
    //   headerName: "Action",
    //   field: "action",
    //   flex: 1.5,
    //   filter: false,
    //   cellStyle: {
    //     display: "flex",
    //     // paddingRight: "30px",
    //     justifyContent: "center",
    //   },
    //   headerClass: "center-header",
    //   cellRenderer: (p) => (
    //     <CardDropdown>
    //       <div className="py-2">
    //         <Dropdown.Item
    //           // as={Link}
    //           onClick={() =>
    //             // navigate(`/libraries/categories/add-new-category/?id=${p.data.id}`)
    //             // () =>
    //             handleRowClick(p.data)
    //           }
    //           // href="/products/add-product"
    //           className="d-flex align-items-center gap-2 py-0"
    //         >
    //           <MdOutlineModeEdit />
    //           Edit
    //         </Dropdown.Item>
    //         {/* <Dropdown.Item
    //           // onClick={() => handleDelete()}
    //           className="d-flex align-items-center gap-2 py-0"
    //         >
    //           <MdDeleteOutline />
    //           Delete
    //         </Dropdown.Item> */}
    //       </div>
    //     </CardDropdown>
    //   ),
    // },
  ]);

  const handleRowClick = (data) => {
    if (data) {
      setStoreInformationData(data);
      // navigate(`${CONSTANT_ROUTES.SELLER_ADD}`, { state: data });
    }
    // if (data) {
    //     navigate(`${CONSTANT_ROUTES.SELLER_ADD}`, { state: data });
    // }
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    // floatingFilter: true,
    // flex: 1,
    // rowDrag: true,
  };

  //   ===============Custom Api Call start================

  let gridApi;
  let columnApi;

  const onGridReady = useCallback(
    (e) => {
      gridApi = e.api;
      columnApi = e.columnApi;
      BanksAPI.get({ params: { sellerId: location?.state?.id } }).then(
        (res) => {
          e.api.applyTransaction({ add: res?.data?.data });
        },
      );
    },
    [window],
  );

  const saveState = useCallback(() => {
    saveColumnState("carts-table", columnApiRef);
  }, []);

  const restoreState = useCallback(() => {
    restoreColumnState("carts-table", columnApiRef);
  }, []);

  const resetState = useCallback(() => {
    resetColumnState("carts-table", columnApiRef);
  }, []);

  const onFilterTextBoxChanged = useCallback(() => {
    columnApiRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value,
    );
  }, []);

  return (
    <div
      className={`${
        isDarkBool || isDarkTheme || auto
          ? "ag-theme-quartz-dark"
          : "ag-theme-quartz"
      } rounded-0`} // applying the grid theme
      // style={{ height: "100vh" }} // the grid will fill the size of the parent container
    >
      <Card style={{ height: `calc(80vh - 4rem)`, overflow: "auto" }}>
        {/* <Card.Header className="d-flex justify-content-between align-items-center">
                        <BreadCrumbTable title="Shopenze" subTitle="Sellers" />
                        <div className="d-flex align-items-center gap-2">
                            <Form className="position-relative">
                                <FontAwesomeIcon
                                    icon="search"
                                    className="position-absolute text-400 search-box-icon"
                                    style={{
                                        left: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                    }}
                                />
                                <Form.Control
                                    type="search"
                                    placeholder="Search..."
                                    style={{
                                        paddingLeft: "30px",
                                    }}
                                    aria-label="Search"
                                    id="filter-text-box"
                                    className="rounded-pill search-input"
                                    onInput={onFilterTextBoxChanged}
                                />
                            </Form>
                        </div>
                    </Card.Header> */}

        <Card.Body className="p-0">
          {storeInformationData ? (
            <>
              <AddBank
                data={storeInformationData}
                setStoreInformationData={setStoreInformationData}
              />
            </>
          ) : (
            <>
              <AgGridReact
                // rowData={rowData}
                ref={columnApiRef}
                onGridReady={onGridReady}
                pagination
                paginationPageSize={settings.paginationSize}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                onRowDoubleClicked={(params) => handleRowClick(params.data)}
                overlayNoRowsTemplate="Nothing found - Looks empty over here"
              />
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
}
